<template>
    <div>
        <div >
            <el-form  :model="ecxForm" :rules="actrules" ref="ecxForm"
                      label-width="150px" class="demo-ruleForm"  >
                <el-form-item label="提货码名称" prop="excodeName">
                    <el-input v-model="ecxForm.excodeName" placeholder="提货码信息名称"
                              style="width: 60%;" ></el-input>
                </el-form-item>

                <el-form-item label="商品名称" v-for="(item,index) in productList"
                              v-if="productList.length>0">
                    <el-input :value="item.name" disabled="disabled" style="width: 30%;"></el-input>
                    <el-button  @click="delProductInfo(index)">删除</el-button>
                </el-form-item>

                <el-form-item label="提货码信息类型" prop="excodeType">
                    <el-select v-model="ecxForm.excodeType" placeholder="提货码信息类型" @change="showFile()">
                        <el-option value="0" label="系统生成">系统生成</el-option>
                        <el-option value="1" label="预生成">预生成</el-option>
                    </el-select>
                    <el-button v-show="isShow" @click="export2Excel()">生成取货码表格</el-button>
                </el-form-item>

                <el-form-item label="机器编号" prop="kioskNo">
                    <el-select v-model="ecxForm.kioskNo" placeholder="机器编号" @change="getProductList()">
                        <el-option label="K1-A112" value="K1-A112" >K1-A112</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="提货码商品信息" prop="product">
                    <el-select v-model="prodindex" placeholder="提货码商品信息">
                        <el-option
                                v-for="(item,index) in products"
                                :label="item.productName"
                                :value="index"
                        >
                        </el-option>
                    </el-select>
                    <el-button  @click="setProductInfo()">添加</el-button>
                </el-form-item>

                <el-form-item label="出货类型" prop="productType">
                    <el-select v-model="ecxForm.productType" placeholder="出货类型">
                        <el-option value="All" label="全部出货">全部出货</el-option>
                        <el-option value="Ran" label="随机一件">随机一件</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="ecxForm.excodeType==0" label="提货码总数量" prop="count">
                    <el-input v-model="ecxForm.count" placeholder="提货码总数量" style="width: 30%;"></el-input>
                </el-form-item>

                <el-form-item label="提货码备注" prop="remark">
                    <el-input v-model="ecxForm.remark" placeholder="提货码备注" style="width: 30%;"></el-input>
                </el-form-item>

                <!--<el-form-item label="过期时间" prop="expDate">
                  <el-date-picker
                    v-model="ecxForm.expDate"
                    type="datetime"

                    placeholder="选择日期"
                    @change="getStartDate"
                  >
                  </el-date-picker>
                </el-form-item>-->

                <el-form-item label="活动开始时间" prop="startTime">
                    <el-date-picker
                            v-model="ecxForm.startTime"
                            type="datetime"

                            placeholder="选择日期"
                            @change="getStartTime"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="活动结束时间" prop="endTime">
                    <el-date-picker
                            v-model="ecxForm.endTime"
                            type="datetime"

                            placeholder="选择日期"
                            @change="getEndTime"
                    >
                    </el-date-picker>
                </el-form-item>


                <el-form-item label="提货码刷新周期" prop="isExp" >
                    <el-select v-model="ecxForm.isExp" placeholder="提货码刷新周期" @change="isExpType()">
                        <el-option value="0" label="不刷新">不刷新</el-option>
                        <el-option value="1" label="刷新">刷新</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="提货码刷新时长(秒)" prop="expSecond" v-show="isexpSecond">
                    <el-input  v-model="ecxForm.expSecond" placeholder="提货码刷新时长" style="width: 30%;"></el-input>
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="ecxForm.status" @change="radioStatus">
                        <el-radio label="1" value="1">启用</el-radio>
                        <el-radio label="0" value="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item prop="fileList">
                    <el-upload
                            class="upload-demo"
                            ref="upload"

                            :action="uploadurl"
                            :data="upload_data"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-success="handleSuccess"
                            :before-upload="handletype"
                            :file-list="ecxForm.fileList"
                    >
                    <span v-bind:class="{isable:isorno}">
                            <el-button size="small" type="success">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">大小不超过5GB</div>
                        </span>
                    </el-upload>
                </el-form-item>

                <el-form-item label="表格名称" prop="exlName" v-show="false">
                    <el-input v-model="ecxForm.exlName" placeholder="videoUrl" style="width: 60%;" >

                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary"  @click="submitForm('ecxForm')"
                               id="primary" :disabled="isorgsubmit">确 定</el-button>
                    <el-button @click="resetForm('ecxForm')">重 置</el-button>
                </el-form-item>

            </el-form>

        </div>
    </div>
</template>
<script>
    import moment  from 'moment'
//    import { product, productUpdate, categoryProduct } from '@/assets/api.js'
    export  default{
        data(){
            var validateExcodeType = (rule, value, callback) => {
                if(value === "1"){
                    if (this.ecxForm.exlName !== "" && this.ecxForm.exlName !== null){
                        callback();
                    }else {
                        callback(new Error('请导入相应的文件'));
                    }
                }else {
                    callback();
                }
            };
            return{
                url:this.requetCodeHost+"/exManager/saveExcode",
                //uploadurl:this.requetHost+"/exManager/UplodExlFile",
                uploadurl:"http://47.99.129.28:80/activity/exManager/UplodExlFile",
                pushURL: this.productURL+"/vueFeign/getProductPutaway",
                isorno:true,
                isShow:false,
                isexpSecond:false,
                isorgsubmit:false,
                resourceType:"",
                labelposition:"left",
                upload_data:{
                    type:this.apkUploadWay,
                    folder:"app"
                },
                prodindex:0,
                productList:[],
                ecxForm:{
                    excodeName:'',
                    kioskNo:'K1-A112',
                    product:[],
                    expDate:'',
                    remark:'',
                    count:'',
                    exlName:'',
                    status:'',
                    excodeType:'',
                    productType:'',
                    isExp:'',
                    expSecond:'',
                    fileList:[],
                    quantity:1,
                    startTime:'',
                    endTime:''
                },
                products:[],
                isorginit:'1',
                actrules: {
                    excodeName: [
                        { required: true, message: '请输入提货码名称', trigger: 'blur' },
                        /*{ validator: validateactName, trigger: 'blur' },*/
                        { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' }
                    ],
                    count: [
                        { required: true, message: '请输入商品数量', trigger: 'change' }
                    ],
                    startTime: [
                        { required: true, message: '请选择活动开始时间', trigger: 'change' }
                    ],
                    endTime: [
                        { required: true, message: '请选择活动结束时间', trigger: 'change' }
                    ],
                    status: [
                        { required: true, message: '请选择状态', trigger: 'change' }
                    ],
                    productType: [
                        { required: true, message: '请选择出货类型', trigger: 'change' }
                    ],
                    isExp: [
                        { required: true, message: '请选择提货码刷新周期', trigger: 'change' }
                    ],
                    excodeType: [
                        { required: true, message: '请选择类型', trigger: 'change' },
                        { validator: validateExcodeType, trigger: 'change' },
                    ]
                }
            }
        },
        created(){
            this.getProductList();
        },
        methods:{
            setProductInfo(){
                if(this.products[this.prodindex].id==''||this.products[this.prodindex].id==undefined||this.products[this.prodindex].id==null){
                    this.$message({showClose: true,message: '请选择商品',type: 'error'});
                }else{
                    var productStr = this.products[this.prodindex].id+"&"+this.products[this.prodindex].productName
                        +"&"+this.products[this.prodindex].SKU+"&"+this.products[this.prodindex].UPC+"&"
                        +this.products[this.prodindex].price+"&"+this.ecxForm.quantity;
                    if(!this.in_array(productStr,this.ecxForm.product)){
                        this.ecxForm.product.push(productStr);
                        this.productList.push({"name":this.products[this.prodindex].productName,"quantity":this.ecxForm.quantity});
                    }else{
                        this.$message({showClose: true,message: '请勿添加重复商品',type: 'error'});
                    }
                }
            },
            delProductInfo(index){
                console.log(index);
                console.log("before1:"+this.ecxForm.product[index]);
                console.log("before2:"+this.productList[index]);
                this.ecxForm.product.splice(index, 1);
                this.productList.splice(index, 1);
                console.log("after1:"+this.ecxForm.product[index]);
                console.log("after2:"+this.productList[index]);
            },
            getProductList(){
                var params = {kioskNo:this.ecxForm.kioskNo,tenantId:this.getcookie('storeId'),
                    productName:'',SKU:''};
                //异步请求
                this.$http.post(this.pushURL,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.products = response.body.Data.data
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            in_array(str, array) {
                for (var s = 0; s < array.length; s++) {
                    var thisEntry = array[s].toString();
                    if (thisEntry == str) {
                        return true;
                    }
                }
                return false;
            },
            submitForm(formName) {
                if(this.ecxForm.product+"" === ""){
                    this.$message({showClose: true,message: '请点击添加选择此商品',type: 'error'});
                    return false;
                }
                if(this.ecxForm.isExp +"" === "1"){
                    if(this.ecxForm.expSecond <= 0){
                        this.$message({showClose: true,message: '请输入过期时间，最少大于一天',type: 'error'});
                        return false;
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.isorgsubmit = true;
                        var params={excodeName:this.ecxForm.excodeName,excodeType:this.ecxForm.excodeType,products:this.ecxForm.product+"",count:this.ecxForm.count
                            ,expDate:this.ecxForm.endTime,remark:this.ecxForm.remark,status:this.ecxForm.status,fileName:this.ecxForm.exlName,
                            productType:this.ecxForm.productType,isExp:this.ecxForm.isExp,expSecond:this.ecxForm.expSecond
                            ,Token: '',startTime:this.ecxForm.startTime,endTime:this.ecxForm.endTime}
                        this.$http.post(this.url,params).then((response)=>{
                            var data=response.body;
                            if(data.res=="success") {
                                this.$message({showClose: true, message: '保存成功', type: 'success'});
                                this.$router.push({path: "excodeManager"})
                            }else if(data.code == "501"){
                                this.$message({showClose: true,message: data.msg ,type: 'error'});
                            }else{
                                this.$message({showClose: true,message: '参数错误',type: 'error'});
                            }
                        },()=>{
                            this.$message({showClose: true,message: '网络异常',type: 'error'});
                        })

                    }else{
                        console.log('error submit!!');
                        return false
                    }
                });
            },
            handletype(file) {
                var n = file.name.split(".");
                var len =n.length;
                var type = n[len-1];
                if(type!=="xls" && type !== "xlsx") {
                    this.$message({showClose: true, message: '只能选择.xls', type: 'error'});
                    this.clear("upload");
                    return false;
                }
                if(this.ecxForm.fileList.length>=0){
                    this.isorno=true;
                };
            },
            handleRemove(file, fileList) {
                this.isorno=false;
                this.ecxForm.fileList = fileList;
            },
            handlePreview(file) {
            },
            handleSuccess(response, file, fileList){
                this.ecxForm.fileList = fileList;
                this.ecxForm.exlName = response.path;
            },

            submitUpload(fileList) {
                this.$refs.upload.submit();
            },
            getStartDate(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.ecxForm.expDate=moment(d).format(formatString);
            },
            showFile(){
                this.isShow=true;
                this.isorno=type;
                var type = this.ecxForm.excodeType
                if (type === '0'){
                    this.isorno=true;
                    this.isShow=false;
                }
            },
            getStartTime(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.ecxForm.startTime=moment(d).format(formatString);
            },
            getEndTime(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.ecxForm.endTime=moment(d).format(formatString);;
            },
            isExpType(){
                this.isexpSecond=true;
                var type = this.ecxForm.isExp
                if (type === '0'){
                    this.ecxForm.expSecond = 0;
                    this.isexpSecond=false;
                }
            },
            radioStatus(vue){
                this.ecxForm.status = vue;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            clear(name) {
                this.$refs[name].clearFiles();
            },
            export2Excel() {
                var codeList= [{name:'001',status:0},{name:'002',status:0},{name:'003',status:0}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../vendor/Export2Excel');
                    const tHeader = ['优惠券码','优惠券状态'];
                    const filterVal = ['name','status'];
                    const list = codeList;
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '提货码列表');
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
        }
    }
</script>
<style>
    .isable{
        display:none;
    }
    .demo-ruleForm{

        margin: 30px auto 0 auto;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// ExcodeAdd.vue?0b1f8ade